/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { largerDependencies } from './dependenciesLarger.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMax } from '../../factoriesAny.js';
export var maxDependencies = {
  largerDependencies: largerDependencies,
  typedDependencies: typedDependencies,
  createMax: createMax
};